import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UserDetailsModel } from "@theStellarBlueprint/CustomApiModels";
import {LoadPurchasedItemsState} from "@theStellarBlueprint/Store/Data/PurchasedItems/LoadPurchasedItemsState";
import { Draft } from "immer";

const initialLoadPurchasedItemsState: LoadPurchasedItemsState = {
    isLoading: false,
    value: undefined,
    dataNotFound: false,
};

const reducer = {
    "Custom/Users/BeginLoadOrders": (draft: Draft<LoadPurchasedItemsState>) => {
        draft.isLoading = true;
    },
    "Custom/Users/CompleteLoadUsersData": (
        draft: Draft<LoadPurchasedItemsState>,
        action: { result: UserDetailsModel },
    ) => {
        draft.isLoading = false;
        draft.value = action.result;
        if (!action.result) {
            draft.dataNotFound = true;
        } else {
            draft.dataNotFound = false;
        }
    },
};

export default createTypedReducerWithImmer(initialLoadPurchasedItemsState, reducer);
